<template>
    <div class="art-cont">
                    <h1 class="fs28 lh38">横琴创新应用“澳优码”亮相首届BEYOND国际科技创新博览会</h1>
                    <div class="title-info">2021-12-10</div>
                    <div class="main-content">
                        <p>
	<span style="color:#515151;font-family:" >一款产品“遇见你”之前，都经历了什么？在近日举行的首届BEYOND国际科技创新博览会“澳优码”展位上，记者用手机扫描一款“龙泉青瓷点彩杯”包装盒上的二维码，产品详情、质量追溯、企业文化等信息映入眼帘，区块链ID清晰可见，原料、成型、晾坯、修坯、素烧、上釉、釉烧等生产工序一目了然，实现原料、生产、流通等全生命周期追溯。</span>
</p>
<p>
	<span style="color:#515151;font-family:" ><img src="/core/extend/kindeditor/attached/image/20220605/20220605033109_51635.png" alt="" ondragstart="return false"><br>
</span>
</p>
<p>
	<span style="color:#515151;font-family:" >
	</span></p><p style="margin-top:0px;margin-bottom:20px;padding:0px;box-sizing:border-box;list-style:none;border:0px;color:#515151;font-family:">
		2020年8月，在国家工信部的支持下，由中国信息通信研究院牵头的国家级区块链与工业互联网新型融合基础设施——“星火·链网”正式启动。“澳优码”则是基于“星火·链网”（珠海横琴）骨干节点打造的一款创新应用，由浪潮集团联合横琴融贯投资科技有限公司、普华永道等10家机构共同研发，提供一键追溯、质量保障、数字营销、价值回馈等多重功能。
	</p>
	<p style="margin-top:0px;margin-bottom:20px;padding:0px;box-sizing:border-box;list-style:none;border:0px;color:#515151;font-family:">
		中共中央、国务院印发的《横琴粤澳深度合作区建设总体方案》提出，对在澳门审批和注册、在合作区生产的中医药产品、食品及保健品，允许使用“澳门监造”“澳门监制”或“澳门设计”标志。“我们打造的这款‘澳优码’，主要面向横琴粤澳深度合作区及粤港澳大湾区提供区块链和工业互联网标识解析等服务，通过‘数字身份、一物一码’，构建质量保障立体体系，助力‘澳门监造’‘澳门监制’‘澳门设计’。”&nbsp;横琴融贯投资科技有限公司董事长冯文滔介绍说。
	</p>
	<p style="margin-top:0px;margin-bottom:20px;padding:0px;box-sizing:border-box;list-style:none;border:0px;color:#515151;font-family:">
		在博览会现场，赋有“澳优码”的多种产品亮相展示，吸引参展者驻足观看、扫码体验。据了解，“澳优码”已建立中医药行业的“中药链”、食品行业的“茶叶链”，“陈李济”中药、梧州六堡茶等知名品牌均已应用赋码。
	</p>
	<p style="margin-top:0px;margin-bottom:20px;padding:0px;box-sizing:border-box;list-style:none;border:0px;color:#515151;font-family:">
		在前不久举行的2021粤港澳数字贸易创新应用峰会暨“星火·链网”（珠海横琴）骨干节点-横琴粤澳链发布会上，横琴融贯等数十家机构举行了创新应用签约仪式，共筑“澳优码”生态，实现澳门及内地商品“一码通用”，数据安全可信、互通互融，促进数字技术深度赋能数字经济，助力澳门产业多元发展与数字化转型。
	</p>
<br>

<p></p>
<p>
	<span style="color:#515151;font-family:" ><br>
</span>
</p>
                    </div>
                    <div class="art-bott flex flex-wrap-wrap flex-justify-between flex-align-center">
                        <a href="/News/1" class="art-btn btn-hvr" ondragstart="return false">返回</a>
                        
                    </div>
                    <div class="arc-nav">
                        <a href="/NewsDetail/34" ondragstart="return false">上一条 :  关于我们</a>
                        <a href="/NewsDetail/36" ondragstart="return false">下一条 : 星火体系 | “星火·链网”骨干节点（珠海横琴）创新应用——“澳优码”亮相澳门科技博览会</a>
                    </div>
                </div>
</template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .article .art-cont {
    background: #fff;
    width: calc(70% - 80px);
    padding: 50px 40px;
    overflow: hidden;
    border-radius: 8px;
}
.article .art-cont h1 {
    color: #333;
    font-weight: 700;
}
    .article .art-cont h1 {
        font-size: 26px;
    }

    .article .art-cont .title-info {
        font-size: 14px;
        color: #888;
        font-family: OPPOSans-H;
        padding-left: 30px;
        height: 20px;
        line-height: 22px;
        background: url(@/assets/images/news-time.png) no-repeat left center;
        margin: 30px 0;
    }

    .article .art-bott {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #f0f0f0;
        align-items: center;
    }
    .article .art-bott .art-btn {
        background: #ea5413;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 110px;
        height: 42px;
        font-weight: 700;
        color: #fff;
        border-radius: 30px;
        transition: all .4s ease;
        font-size: 16px;
    }
    .btn-hvr:hover {
        border-color: transparent;
        box-shadow: 0 0 0 .2rem rgba(234, 84, 19, .5);
    }
    .article .arc-nav a {
        position: relative;
        display: block;
        font-size: 14px;
        color: #666;
        padding-left: 15px;
        transition: all .4s ease;
        font-weight: 700;
    }

  </style>